import axios, { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
	GetWikisDataResponse,
	WikiDataProps,
	WikiData,
	Topic,
	TopicProps,
	GetTopicsResponse,
} from './types/wiki.interfaces'

const URL_WIKI = '2/wiki/v2/wiki'

export const WikiService = {
	async getWikis({
		offset = 0,
		limit = 10,
	}: {
		offset?: number
		limit?: number
	}): Promise<GetWikisDataResponse> {
		const response: AxiosResponse<GetWikisDataResponse> = await apiNode.get(
			`${URL_WIKI}`,
			{
				params: {
					offset,
					limit,
				},
			}
		)
		return response?.data
	},
	async getWiki({
		id,
	}: {
		id: string
	}): Promise<WikiData> {
		const response: AxiosResponse<any> = await apiNode.get(
			`${URL_WIKI}/${id}`,
		)
		return response?.data.data
	},
	async addWiki({ data }: { data: WikiDataProps }) {
		const response: AxiosResponse<GetWikisDataResponse> = await apiNode.post(
			`${URL_WIKI}`,
			data,
		)
		console.log('Wiki added:', response)
		return response.data.data
	},
	async updateWiki({ data }: { data: WikiData }) {
		const response: AxiosResponse<GetWikisDataResponse> = await apiNode.patch(
			`${URL_WIKI}/${data?.id}`,
			data,
		)
		return response?.data
	},
	async deleteWiki({ id }: { id: string }) {
		const response: AxiosResponse<GetWikisDataResponse> = await apiNode.delete(
			`${URL_WIKI}/${id}`,
		)
		return response?.data
	},
	async getTopics({
		startDate,
		endDate,
		timezoneOffset,
		query,
	}: {
		startDate?: string
		endDate?: string
		timezoneOffset?: number | null
		query?: string
	}): Promise<GetTopicsResponse> {
		const response: AxiosResponse<GetTopicsResponse> = await apiNode.get(
			`${URL_WIKI}/topic`,
			{
				params: {
					startDate,
					endDate,
					timezoneOffset,
					query,
				},
			}
		)
		return response?.data
	},
	async createTopic({
		data,
	}: {
		data: TopicProps
	}): Promise<Topic> {
		const response: AxiosResponse<Topic> = await apiNode.post(
			`${URL_WIKI}/topic`,
			data,
		)
		return response?.data
	},
	async updateTopic({
		id,
		data,
	}: {
		id: string
		data: TopicProps
	}): Promise<Topic> {
		const response: AxiosResponse<Topic> = await apiNode.patch(
			`${URL_WIKI}/topic/${id}`,
			data,
		)
		return response?.data
	},
	async deleteTopic({ id }: { id: string }) {
		const response: AxiosResponse<void> = await apiNode.delete(
			`${URL_WIKI}/topic/${id}`,
		)
		return response?.data
	},
	async getWikiPermissions({ id }: { id: string }) {
		const response: AxiosResponse<any> = await apiNode.get(
			`${URL_WIKI}/${id}/permissions`,
		)
		return response?.data
	},
	async updateWikiPermissions({
		id,
		data,
	}: {
		id: string
		data: { userId: string; level: number }[]
	}) {
		const response: AxiosResponse<any> = await apiNode.put(
			`${URL_WIKI}/${id}/permissions`,
			data,
		)
		return response?.data
	},
}
